import React, {useEffect, useState} from 'react';
import {Tooltip} from '@mui/material';
import LockRoundedIcon from '@mui/icons-material/LockRounded';
import styled from 'styled-components';
import {Person} from '@src/types/persons';

const Pill = styled.span`
 display:inline-flex;align-items:center;flex-shrink:0;gap:3px;height:19px;border-radius:10px;
 background:#bb681e;color:#fff;font-size:12px;font-weight:600;white-space:nowrap;
 padding-right:5px;
 &.lock-only {padding-right:0;gap:0;}
 &.needs-staff {background:#bb681e;padding:0;width:19px;justify-content:center;font-size:14px;font-weight:800;}
 &.escalated {background:#c43838;}
 .lock-icon {display:flex;align-items:center;justify-content:center;width:19px;height:19px;border-radius:50%;background:#0002;}
 .MuiSvgIcon-root {width:11px !important;height:11px !important;color:#fff !important;}
`;
export default function TeamLockBadge({state}:{state:Person['team_state']}) {
 const [now,setNow]=useState(()=>Date.now()/1000);
 useEffect(()=>{const timer=setInterval(()=>setNow(Date.now()/1000),1000);return()=>clearInterval(timer);},[]);
 if (!state || now-state.updated_at>90) return null;
 if (state.needs_staff) {
  const label=state.escalated ? 'Escalado al equipo · pendiente de respuesta' : 'Pendiente de respuesta del equipo';
  return <Tooltip title={label} placement="top" disableInteractive><Pill className={'needs-staff'+(state.escalated?' escalated':'')} aria-label={label}>!</Pill></Tooltip>;
 }
 if (!state.owned || !state.due_at) return null;
 const minutes=state.due_at ? Math.max(0,Math.ceil((state.due_at-now)/60)):null;
 const label=minutes===null ? 'Equipo · sin revisión automática programada' : minutes===0 ? 'Equipo · revisión de SusIA pendiente' : `Equipo · revisión de SusIA en ${minutes} minutos`;
 return <Tooltip title={label} placement="top" disableInteractive><Pill aria-label={label} className={minutes===null?'lock-only':undefined}><span className="lock-icon"><LockRoundedIcon/></span>{minutes!==null && <span>{minutes}m</span>}</Pill></Tooltip>;
}
